import React, { useMemo } from 'react'
import PieChart from 'components/PieChart/PieChart'

interface Datum {
    name: string
    count: number
}

interface ChargebacksByStatusProps {
    data: Datum[]
    loading: boolean
}

export const ChargebacksByCardType: React.FC<ChargebacksByStatusProps> = ({
    data,
    loading,
}) => {
    const formattedData = useMemo(
        () =>
            data.map((i) => ({
                name: i.name,
                value: i.count,
            })),
        [data]
    )

    return (
        <div id={'dashboardChargebacksByCardType'}>
            <PieChart
                data={formattedData}
                loading={loading}
                testId="chargebacksByCardType"
                height={350}
                pieLabelLayout={'inside'}
            />
        </div>
    )
}

export default ChargebacksByCardType
